/**
 * @generated SignedSource<<4fa80beeaa9b4fe361020d507d0e7867>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteZnglistInput = {
  clientMutationId?: string | null | undefined;
  forceDelete?: boolean | null | undefined;
  id: string;
  ignoreEditLock?: boolean | null | undefined;
};
export type Znglist_Delete_Mutation$variables = {
  input: DeleteZnglistInput;
};
export type Znglist_Delete_Mutation$data = {
  readonly deleteZnglist: {
    readonly deletedId: string | null | undefined;
  } | null | undefined;
};
export type Znglist_Delete_Mutation$rawResponse = {
  readonly deleteZnglist: {
    readonly deletedId: string | null | undefined;
  } | null | undefined;
};
export type Znglist_Delete_Mutation = {
  rawResponse: Znglist_Delete_Mutation$rawResponse;
  response: Znglist_Delete_Mutation$data;
  variables: Znglist_Delete_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Znglist_Delete_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteZnglistPayload",
        "kind": "LinkedField",
        "name": "deleteZnglist",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Znglist_Delete_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteZnglistPayload",
        "kind": "LinkedField",
        "name": "deleteZnglist",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6ccc1e960948ff907d6d1108c5e144fe",
    "id": null,
    "metadata": {},
    "name": "Znglist_Delete_Mutation",
    "operationKind": "mutation",
    "text": "mutation Znglist_Delete_Mutation(\n  $input: DeleteZnglistInput!\n) {\n  deleteZnglist(input: $input) {\n    deletedId\n  }\n}\n"
  }
};
})();

(node as any).hash = "a3a455d87176791df6f9817247769da6";

export default node;
